"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyStatisticsFields = exports.SurveyQuestionType = void 0;
var SurveyQuestionType;
(function (SurveyQuestionType) {
    SurveyQuestionType["Email"] = "email";
    SurveyQuestionType["Short"] = "short";
    SurveyQuestionType["Long"] = "long";
    SurveyQuestionType["SingleChoice"] = "single_choice";
    SurveyQuestionType["MultipleChoice"] = "multiple_choice";
})(SurveyQuestionType = exports.SurveyQuestionType || (exports.SurveyQuestionType = {}));
var SurveyStatisticsFields;
(function (SurveyStatisticsFields) {
    SurveyStatisticsFields["EventCount"] = "eventCount";
})(SurveyStatisticsFields = exports.SurveyStatisticsFields || (exports.SurveyStatisticsFields = {}));
//# sourceMappingURL=survey.js.map